import React, { useState } from 'react'
import { HiMenuAlt1 } from 'react-icons/hi'
import { Link } from 'react-router-dom'
import logo_light from '../assets/logo-light.webp'
import logo from '../assets/logo.webp'
import time1 from '../assets/time1.webp'
import map from '../assets/map.webp'
import Sidebar from './Sidebar'
import { MdOutlineCancelPresentation } from 'react-icons/md'
export default function Navbar() {

  const [showSideBar, setShowSideBar] = useState(false)


  return (
    <>
      <div className='text-white'>

        {/* WHITE NAVBAR */}
        <div className="hidden bg-white h-28 lg:flex justify-around items-center lg:px-[12vw]">
          <img src={logo} alt="logo" className='p-0' />
          <div className='text-blue-800  ' >
            <img src={time1} alt="logo" className='inline-block mb-6' />
            <div className=' pl-5 pt-6 inline-block'>8 am to 6 pm (Mon - Fri) <br /> 10 am to 8 pm (Sat - Sun)</div>
          </div>
          <div className='text-blue-800 ' >
            <img src={map} alt="map" className='inline-block mb-6' />
            <div className=' pl-5 pt-6 inline-block'>258C, Saintpatrick, Main Street <br />
              Notrth Town, New York</div>
          </div>
        </div>
        <Link to='/contact' className='hidden absolute top-0 h-28 pt-10 right-0 text-xl  p-5  bg-[rgb(9,138,64)] lg:inline-block hover:underline'  >Appointment</Link>

        {/* BLUE NAVBAR */}
        <div className='flex justify-between items-center z-10 bg-[rgb(50,52,157)] lg:justify-evenly lg:py-4 lg:px-[5vw] lg:text-xl'>
          <Link to='/' className='lg:hidden'>
            <img src={logo_light} alt="logo_light" className='h-16 p-2' />
          </Link>
          <Link to='/' className='hidden lg:block' >Home</Link>
          <Link to='/services' className='hidden lg:block' >Services</Link>
          <Link to='/dentist' className='hidden lg:block' >Dentist</Link>
          <Link to='/about' className='hidden lg:block' >About</Link>
          <Link to='/contact' className='hidden lg:block' >Contact</Link>
          <div className='hidden sm:block sm:ml-[45vw] lg:m-0 p-2' >

            <Link to='/blog' className='hidden lg:block' >Blog</Link>
          </div>
          {showSideBar ?
            <MdOutlineCancelPresentation className='h-16 w-16 p-3 bg-[rgb(9,138,64)] lg:hidden' onClick={() => setShowSideBar(false)} /> : <HiMenuAlt1 className='h-16 w-16 p-3 bg-[rgb(9,138,64)] lg:hidden' onClick={() => setShowSideBar(prev => !prev)} />}
        </div>
      </div>

      {showSideBar &&
        <Sidebar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />}
    </>
  )
}
